import React from "react";
import linkArrow from "../../assets/images/link-arrow.svg";
import useStockTickerData from "../../hooks/useStockTickerData";
import { LinkInfo } from "../../models/shared/LinkInfo";
import { isNullOrWhiteSpace } from "../../shared/string";
import SanityLink, { renderLinkTitle } from "../SanityLink";
import { BannerColorTheme, getBannerColorTheme } from "./Common";

export interface BannerSharesProps {
  title?: string;
  link?: LinkInfo;
  colorTheme?: BannerColorTheme;
}

const BannerShares = (props: BannerSharesProps) => {
  const { colorTheme, title, link } = props;

  const { hrColor, textColor, titleColor } = getBannerColorTheme(
    colorTheme ?? BannerColorTheme.Default
  );

  const stockTicker = useStockTickerData();

  if (!stockTicker?.length) {
    return null;
  }

  const [stockTickerData] = stockTicker;

  if (!stockTickerData) {
    return null;
  }

  const ticker = stockTickerData?.tickers[0];

  return (
    <div className="flex flex-col items-start lg:px-4">
      {!isNullOrWhiteSpace(title) && (
        <>
          <h2 className={`${titleColor} text-2xl lg:text-5xl`}>{title}</h2>
          <hr className={`h-divider-thick w-16 mt-4 ${hrColor}`} />
        </>
      )}
      <div className={`text-8xl uppercase font-bold mt-20 ${textColor} leading-snug`}>
        {ticker?.price} {ticker?.tradeCurrency}
      </div>
      <div
        className={`text-3xl font-bold rounded-lg px-4 py-2 ${textColor} bg-brand-primary-70`}
      >
        {ticker?.deltaPercentage && ticker.deltaPercentage >= 0 ? "+" : ""}{" "}
        {ticker?.deltaPercentage?.toFixed(2)}%
      </div>
      {link && (
        <SanityLink
          className="mt-16 flex items-center group font-bold no-underline focus:outline-none focus:shadow-card-outline text-brand-senary-100 border-brand-senary-100 border-b"
          {...link}
        >
          {renderLinkTitle(link)}
          <svg className="card-arrow group-hover:translate-x-1 ml-2 w-4 h-4">
            <use xlinkHref={linkArrow.url} />
          </svg>
        </SanityLink>
      )}
    </div>
  );
};

export default BannerShares;
